// extracted by mini-css-extract-plugin
export default {"guestFeedback":"GuestFeedback-module__guestFeedback___MVzLC"};